import {
  basicPlan, standardPlan, annualPlan, legacyPlan
} from '../modules/price-table/constants'
// import { useFeatureFlags } from './useFeatureFlags'

const usePlanChangeFlag = () => {
  /**
   * In next price change, we only need to use a new set of newPrices(`basicPlanNew`) in constants file and new FF(`2025_price_change`) like below
   */
  // const displayNewPrice = useFeatureFlags(['2025_price_change'])

  // if (displayNewPrice['2025_price_change']) {
  //   return {
  //     basic: basicPlanNew,
  //     standard: standardPlan,
  //     annual: annualPlan,
  //     legacy: legacyPlan
  //   }
  // }

  return {
    basic: basicPlan,
    standard: standardPlan,
    annual: annualPlan,
    legacy: legacyPlan
  }
}

export { usePlanChangeFlag }
